import {
  apiFetch,
  defaultHeaders,
  getAccessTokenFromStore,
  getAuthorizationHeaders,
  getRefreshTokenFromStore,
} from 'utils/fetch';
import {
  RefreshTokenResponse,
  SCPUserResponse,
  Tokens,
  UserGroup,
  UserGroupResponse,
  UserPasswordPolicy,
  UserPasswordPolicyResponse,
  UserRole,
  UserRoleResponse,
} from 'models';
import * as config from 'config';

export async function getUserInfo(): Promise<SCPUserResponse> {
  const headers = getAuthorizationHeaders();
  const url = `${config.backendApi}/isim/user-info`;

  const json = await apiFetch<any>(url, { headers });
  return json.data;
}

export async function getUserGroups(): Promise<UserGroup[]> {
  const headers = getAuthorizationHeaders();
  const url = `${config.backendApi}/diam/groups`;

  const json = await apiFetch<UserGroupResponse>(url, { headers });

  return json.data;
}

export async function getUserRoles(): Promise<UserRole[]> {
  const headers = getAuthorizationHeaders();
  const url = `${config.backendApi}/diam/roles`;

  const json = await apiFetch<UserRoleResponse>(url, { headers });

  return json.data;
}

export async function getPasswordPolicies(): Promise<UserPasswordPolicy[]> {
  const headers = getAuthorizationHeaders();
  const url = `${config.backendApi}/diam/password-policies`;

  const json = await apiFetch<UserPasswordPolicyResponse>(url, { headers });

  return json.data;
}

export async function logout(): Promise<void> {
  const accessToken = getAccessTokenFromStore();
  const url = `${config.backendApi}/isim/logout`;

  return apiFetch<any>(url, {
    headers: defaultHeaders,
    method: 'POST',
    body: JSON.stringify({ accessToken }),
  });
}

export async function refreshToken(): Promise<Tokens> {
  const refreshTokenId = getRefreshTokenFromStore();
  const tokenId = getAccessTokenFromStore();
  const url = `${config.backendApi}/isim/refresh`;
  const body = JSON.stringify({ refreshTokenId, tokenId });

  const res = await fetch(url, {
    method: 'POST',
    headers: defaultHeaders,
    body,
  });

  if (!res.ok) {
    throw new Error('Could not refresh token');
  }

  const json = await res.json() as unknown as RefreshTokenResponse;
  return json.data?.attributes;
}
